import React, { useMemo }  from 'react'
import { View, StyleSheet } from 'react-native'
import { Icon, Text, useTheme } from '@ui-kitten/components'
import { FontAwesome5 } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'
import { currencyFormatterAtom, storesDictAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import OperationsList from '../../components/OperationsList'
import { manufactureExportRows } from '../../utils/manufactureExport'

export default function ManufacturesScreen({ navigation, initialRange=null }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const storesDict = useAtomValue(storesDictAtom)

  // Export transformer for manufactures data
  const exportManufacturesDataTransformer = useMemo(() => {
    return (items, t) => manufactureExportRows(items, t, { storesDict, usersDict })
  }, [usersDict, storesDict])
  
  const renderItemFieldsToShow = (item, date) => {
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
          <Icon name='credit-card-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.totalSum)}
          </Text>
        </View>
        <View style={styles.dateTimeView}>
          <FontAwesome5 name="building" size={16} color={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {storesDict?.[item.store]?.name}
          </Text>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {usersDict[item.cashierUID]?.name}
          </Text>
        </View>  
        <View style={styles.dateTimeView}>
          <Icon name='pricetags-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.product?.name}
          </Text>
        </View>
        <View style={styles.dateTimeView}>
          <Icon name='bar-chart-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.quantity}
          </Text>
        </View>
      </>
    )
  }
  
  return (
    <View style={styles.container}> 
      <OperationsList collectionName='manufactures' dateField={'date'} additionalFilters={null}
        detailScreenName={'ManufactureDetail'} topView={() => {return null}} initialRange={initialRange}
        showTotalSum={false} totalSumFormatter={currencyFormatter} totalSumField={'totalSum'}
        showAddButton={true} additionalDataValidation={() => {}} detailScreenParams={{}}
        renderItemFieldsToShow={renderItemFieldsToShow} navigation={navigation} showStoreFilter={true}
        showExportButtons={true}
        exportDataTransformer={exportManufacturesDataTransformer}
        exportFilenamePrefix='manufactures'
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
})
